/**
* Google Autocomplete
*
* @see https://www.npmjs.com/package/google-address-autocomplete
*/

window.AddressAutocomplete = require('google-address-autocomplete');
